import { HasFactoryWaterMark } from '../../../../classes/class-helpers/factory';
import { ConstructClassWithPrivateMembers } from '../../../../misc/helpers/ClassWithPrivateMembers';
import { DISTINCT_ASYNC_VALUE_OBSERVABLE_PRIVATE } from './privates';
import { InitObservableHook } from '../../../../core/observable/hook/init';
import { NewAsyncDistinctValueObservableContext } from './context/implementation';
import { IsObject } from '../../../../helpers';
export function ConstructAsyncDistinctValueObservable(instance, context, create) {
    ConstructClassWithPrivateMembers(instance, DISTINCT_ASYNC_VALUE_OBSERVABLE_PRIVATE);
    const privates = instance[DISTINCT_ASYNC_VALUE_OBSERVABLE_PRIVATE];
    privates.context = context;
    privates.promise = null;
    privates.controller = null;
    InitObservableHook(instance, privates, NewAsyncDistinctValueObservableContext, create);
}
export function IsAsyncDistinctValueObservable(value) {
    return IsObject(value)
        && value.hasOwnProperty(DISTINCT_ASYNC_VALUE_OBSERVABLE_PRIVATE);
}
export const IS_ASYNC_VALUE_OBSERVABLE_CONSTRUCTOR = Symbol('is-async-value-observable-constructor');
export function IsAsyncDistinctValueObservableConstructor(value) {
    return (typeof value === 'function')
        && HasFactoryWaterMark(value, IS_ASYNC_VALUE_OBSERVABLE_CONSTRUCTOR);
}
//# sourceMappingURL=constructor.js.map